import * as React from "react";
import { useDispatch } from "react-redux";
import { AlertType } from "../../store/AlertStore/models";
import { Action, StateToUpdate } from "../../store/LegacyStore/actions";
import { UWG4InternalStorage } from "../../store/LegacyStore/models/uwg4";
import { popupAlert } from "../../Utility";

type Props = {
    isConnected: boolean,
    state: UWG4InternalStorage,
    invokeAction(action: Action): void,
    updateState(value: any, toUpdate: StateToUpdate): void
}

export const UWG4StateComponent = (props: Props) => {
    // Component state mapped from props
    const [serverIp, setServerIp] = React.useState(props.state.serverIp + ":" + props.state.serverPort);
    const [serialNumber, setSerialNumber] = React.useState(props.state.serialNumber || "");
    const [email, setEmail] = React.useState(props.state.email || "");
    const [name, setName] = React.useState(props.state.name || "");
    const [zipCode, setZipCode] = React.useState(props.state.zipCode || "");
    const dispatch = useDispatch();

    React.useEffect(() => {
        setSerialNumber(props.state.serialNumber);
        setEmail(props.state.email);
        setName(props.state.name);
        setZipCode(props.state.zipCode);
    }, [props.state, setSerialNumber, setEmail, setName, setZipCode]);

    const update = (value: any, toUpdate: StateToUpdate): void => {
        props.updateState(value, toUpdate);
        popupAlert(dispatch, "State saved!", "You have successfully saved the thermostat state.", AlertType.SUCCESS);
    };

    // Render
    return (
        <div className="ml-2 mr-2">
            <table className="table table-sm mt-2 mb-0">
                <tbody>
                    <tr>
                        <th>Server url</th>
                        <td><input
                            className="form-control form-control-sm"
                            value={serverIp || ""}
                            readOnly={props.isConnected}
                            onChange={(e) => setServerIp(e.target.value)}
                            style={{ fontSize: "1rem" }} /></td>
                        <td><button
                            className="btn btn-sm btn-outline-primary ml-2"
                            disabled={props.isConnected}
                            onClick={() => update(serverIp, StateToUpdate.ServerURL)}>
                            Save</button></td>
                    </tr>
                    <tr>
                        <th>Serial number</th>
                        <td><input
                            className="form-control form-control-sm"
                            value={serialNumber || ""}
                            disabled={props.isConnected}
                            onChange={(e) => setSerialNumber(e.target.value)} style={{ fontSize: "1rem" }} /></td>
                        <td><button
                            className="btn btn-sm btn-outline-primary ml-2"
                            disabled={props.isConnected}
                            onClick={() => update(serialNumber, StateToUpdate.SerialNumber)}>
                            Save</button></td>
                    </tr>
                    <tr>
                        <th>Email</th>
                        <td><input
                            className="form-control form-control-sm"
                            value={email || ""}
                            onChange={(e) => setEmail(e.target.value)} style={{ fontSize: "1rem" }} /></td>
                        <td><button
                            className="btn btn-sm btn-outline-primary ml-2"
                            onClick={() => update(email, StateToUpdate.Email)}>
                            Save</button></td>
                    </tr>
                    <tr>
                        <th>Name</th>
                        <td><input
                            className="form-control form-control-sm"
                            value={name || ""}
                            disabled={!props.isConnected}
                            onChange={(e) => setName(e.target.value)} style={{ fontSize: "1rem" }} /></td>
                        <td><button
                            className="btn btn-sm btn-outline-primary ml-2"
                            disabled={!props.isConnected}
                            onClick={() => update(name, StateToUpdate.Name)}>
                            Save</button></td>
                    </tr>
                    {<tr>
                        <th>Zip code</th>
                        <td><input
                            className="form-control form-control-sm"
                            value={zipCode || ""}
                            disabled={!props.isConnected}
                            onChange={(e) => setZipCode(e.target.value)} style={{ fontSize: "1rem" }} /></td>
                        <td><button
                            className="btn btn-sm btn-outline-primary ml-2"
                            disabled={!props.isConnected}
                            onClick={() => update(zipCode, StateToUpdate.ZipCode)}>
                            Save</button></td>
                    </tr>}

                    {/*Text fields that are not editable*/}
                    {<tr>
                        <th>City</th>
                        <td><input
                            className="form-control form-control-sm"
                            value={props.state.city || ""}
                            readOnly={true}
                            style={{ fontSize: "1rem" }} /></td>
                    </tr>}
                    <tr>
                        <th>Software Version</th>
                        <td><input
                            className="form-control form-control-sm"
                            value={props.state.softwareVersion || ""}
                            readOnly={true}
                            style={{ fontSize: "1rem" }} /></td>
                    </tr>
                    {<tr>
                        <th>Distributor Id</th>
                        <td><input
                            className="form-control form-control-sm"
                            value={props.state.distributorId || ""}
                            readOnly={true}
                            style={{ fontSize: "1rem" }} /></td>
                    </tr>}

                    {/*Toggles*/}
                    <tr>
                        <th>Daylight Savings</th>
                        <td>{props.state.useDaylightSavingsTime ? "Using daylight savings" : "Not using daylight savings"}</td>
                    </tr>
                    <tr>
                        <th>Confirmed</th>
                        <td>{props.state.isConfirmed ? "Confirmed" : "Not confirmed"}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};